export var IntelligentPhotoCaptureEstimatorContentType;
(function (IntelligentPhotoCaptureEstimatorContentType) {
    IntelligentPhotoCaptureEstimatorContentType["DAMAGE"] = "Damage";
    IntelligentPhotoCaptureEstimatorContentType["FRONTLEFT"] = "FrontLeft";
    IntelligentPhotoCaptureEstimatorContentType["FRONTRIGHT"] = "FrontRight";
    IntelligentPhotoCaptureEstimatorContentType["LICENSEPLATE"] = "LicensePlate";
    IntelligentPhotoCaptureEstimatorContentType["ODOMETER"] = "Odometer";
    IntelligentPhotoCaptureEstimatorContentType["REARLEFT"] = "RearLeft";
    IntelligentPhotoCaptureEstimatorContentType["REARRIGHT"] = "RearRight";
    IntelligentPhotoCaptureEstimatorContentType["VIN"] = "VinWindshield";
    IntelligentPhotoCaptureEstimatorContentType["VIN_STICKER"] = "VinSticker";
    IntelligentPhotoCaptureEstimatorContentType["VIN_DECODE"] = "VinDecode";
})(IntelligentPhotoCaptureEstimatorContentType || (IntelligentPhotoCaptureEstimatorContentType = {}));
//# sourceMappingURL=IntelligentPhotoCaptureEstimatorContentType.js.map